import { cn } from "../../lib/utils";

export const Spinner = ({ className }: { className: string }) => {
  return (
    <div className={cn("flex justify-center gap-4 p-4 card", className)}>
      <div className="flex items-center gap-2 text-text">
        <span className="h-6 w-6 block rounded-full border-4 border-t-main animate-spin" />
        loading...
      </div>
    </div>
  );
};
